import { Button, Tooltip } from "antd";

const DefaultIcon = (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="10" y="3" width="4" height="18" rx="1" />
    <rect x="3" y="10" width="18" height="4" rx="1" />
  </svg>
);

const MotionIconButton = ({
  text,
  tooltip,
  icon = DefaultIcon, // Set default icon here
  onClick,
  size = "large",
  color = "from-indigo-400 to-purple-900"
}) => {
  return (
    <Tooltip title={tooltip} placement="top">
      <div
        className="
      inline-block
      transition-all duration-300
      hover:scale-110 hover:rotate-6
      active:scale-90
    "
      >
        <Button
          type="primary"
          size={size}
          icon={icon}
          shape="circle"
          onClick={onClick}
          className={`bg-gradient-to-r ${color} text-white bg-[#3f3fc2]
                 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1`}
        >
          {text}
        </Button>
      </div>
    </Tooltip>

  );
};

export default MotionIconButton;
